import { render } from "./actualLevelSelector.vue?vue&type=template&id=6ba2f870&ts=true"
import script from "./actualLevelSelector.vue?vue&type=script&lang=ts"
export * from "./actualLevelSelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__